import BaseModel from '../../base/BaseModel.model';
export default class LanguageLabel extends BaseModel {

    public key?: string;
    public value?: string; 
    public languageId?:string;
    public languageGroupId?: string;
    constructor(){
        super();
        this.init();
    }

    init(){
        this.key = "";
        this.value = "";
        this.languageGroupId ="";
        this.languageId = "";
    }
}